import { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { FooterSelectMenuTypeEnum } from 'enums/entity';
import { AffiliatePermissionsEnum } from 'enums/accessTemplates';

import { translate } from 'utils/translate';
import useAuth from 'store/auth';
import usePartners from 'store/partner';
import { AccessChangePartnerPermissions } from 'utils/accessTemplates';
import { revokeNativeNotificationToken } from 'api/requests/notifications';

import { ProfileDrawerSelectedListType } from './types';

type Props = {
  onClose: () => void;
  onChangePassword: () => void;
  setOpenSelectList: (type: ProfileDrawerSelectedListType) => void;
  permission?: AffiliatePermissionsEnum;
};

const ProfileDrawerMainMenu: FC<Props> = ({ onClose, onChangePassword, setOpenSelectList, permission }) => {
  const [authState, authAction] = useAuth();
  const [partners] = usePartners();
  const selected = authState?.data?.affiliate?.activePartnerId || authState?.data?.affiliate?.partner?.id;
  const selectedName = partners.data.find((item) => item.id === selected)?.name;

  const handleChangePassword = (): void => {
    onChangePassword();
    onClose();
  };

  const handleLogout = (): void => {
    revokeNativeNotificationToken();
    authAction.logout();
  };

  const handleWebsiteClick = (): void => {
    setOpenSelectList(FooterSelectMenuTypeEnum.PARTNER);
  };

  return (
    <List>
      {AccessChangePartnerPermissions.some((r) => r === permission) && (
        <ListItem>
          <Button
            color="inherit"
            fullWidth
            sx={{ justifyContent: 'space-between', p: 0 }}
            onClick={handleWebsiteClick}
            endIcon={<ArrowForwardIosIcon />}
          >
            <Typography component="span" variant="body1" whiteSpace="nowrap">
              {selectedName}
            </Typography>
          </Button>
        </ListItem>
      )}
      <ListItem disablePadding>
        <ListItemButton
          component={RouterLink}
          to={`/affiliates/${authState?.data?.affiliate?.id}/dashboard`}
          onClick={onClose}
        >
          <ListItemText primary={translate('Profile')} />
        </ListItemButton>
      </ListItem>
      {permission === AffiliatePermissionsEnum.AFFILIATE_USER && (
        <ListItem disablePadding>
          <ListItemButton component={RouterLink} to="/commission-plans/own" onClick={onClose}>
            <ListItemText primary={translate('Commission Plan')} />
          </ListItemButton>
        </ListItem>
      )}
      <ListItem disablePadding>
        <ListItemButton onClick={handleChangePassword}>
          <ListItemText primary={translate('Change Password')} />
        </ListItemButton>
      </ListItem>
      <ListItem disablePadding>
        <ListItemButton onClick={handleLogout}>
          <ListItemText primary={translate('Logout')} sx={{ color: 'custom.red.scale.500' }} />
        </ListItemButton>
      </ListItem>
    </List>
  );
};

export default ProfileDrawerMainMenu;
